<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>David Brown’s varied career as a bus driver, shellfish salesman, civil servant and management consultant (among many other jobs) first led to an interest in knowing what his ancestors had done for a living. And then, as his own grandchildren grew up, he began to wonder where his relatives had come from, and how they had fared in life. Starting from a relatively unremarkable upbringing in the Midlands he discovered a family with roots throughout England – in Poland and Russia – and a diaspora stretching across three continents.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6734fb2c